module.exports = __webpack_public_path__ + "img/delete-not-used-codes.3f18aa5b.svg";